(function () {
  var root = document.querySelector('[data-currency-notice]');
  if (!root) return;

  var DISMISS_KEY = 'ss_currency_notice_dismissed';
  var SHOWN_ONCE_KEY = 'ss_currency_notice_shown';

  var banner = root.querySelector('[data-currency-notice-banner]');
  var textEl = root.querySelector('[data-currency-notice-text]');
  var dismissBtn = root.querySelector('[data-currency-notice-dismiss]');
  var tab = root.querySelector('[data-currency-notice-tab]');

  function currencyLabel(code) {
    try {
      // Friendlier than the bare code where the browser supports it; falls
      // back to the code itself everywhere else rather than showing nothing.
      return new Intl.DisplayNames(undefined, { type: 'currency' }).of(code) || code;
    } catch (e) {
      return code;
    }
  }

  function open() {
    root.hidden = false;
    root.classList.remove('is-collapsed');
    root.classList.add('is-open');
  }
  function collapse() {
    root.classList.remove('is-open');
    root.classList.add('is-collapsed');
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  if (dismissBtn) dismissBtn.addEventListener('click', collapse);
  if (tab) tab.addEventListener('click', open);

  document.addEventListener('soulshine:currency-estimate', function (e) {
    var detail = e.detail || {};
    if (!detail.shown || !detail.currencyCode) return; // nothing was actually converted — stay hidden

    if (textEl) {
      textEl.textContent = 'Prices shown in ' + currencyLabel(detail.currencyCode) +
        ' (' + detail.currencyCode + ') are an estimate. You will be charged in Indonesian Rupiah (IDR) at checkout.';
    }

    var dismissedThisSession = false;
    try { dismissedThisSession = sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}

    if (dismissedThisSession) {
      // Already read it this session — go straight to the small tab rather
      // than interrupting again with the full banner.
      root.hidden = false;
      root.classList.add('is-collapsed');
      return;
    }

    var shownAlreadyThisPage = false;
    try { shownAlreadyThisPage = sessionStorage.getItem(SHOWN_ONCE_KEY) === '1'; } catch (e) {}
    // A short delay so the banner doesn't compete with the page's own load,
    // but only on the first time it appears in a session; a returning
    // visitor who already saw it once shouldn't wait again on every page.
    setTimeout(open, shownAlreadyThisPage ? 0 : 1200);
    try { sessionStorage.setItem(SHOWN_ONCE_KEY, '1'); } catch (e) {}
  });
})();
